<template>
  <div>
    <router-link
      :to="{name: 'sequence_levels', query: queryObjectAllTime}"
      exact
      class="period-link"
    >
      Все время
    </router-link>

    <router-link
      :to="{name: 'sequence_levels', query: queryObject7Days}"
      class="period-link"
    >
      Последние 7 дней
    </router-link>
  </div>
</template>

<script>
import { PERIOD_NAME_7_DAYS } from '../../model/m3level.js';
import { addParamToQueryObject } from '../../util.js';

export default {
  name: 'PeriodSelector',

  props: {
    audienceId: {
      type: Number,
      default: null,
    },

    startLevel: {
      type: Number,
      default: null,
    },

    endLevel: {
      type: Number,
      default: null,
    },

    periodName: {
      type: String,
      default: null,
    },
  },

  computed: {
    queryObjectAllTime() {
      return this.createBaseQueryObject();
    },

    queryObject7Days() {
      const base = this.createBaseQueryObject();
      base.period = PERIOD_NAME_7_DAYS;
      return base;
    },
  },

  methods: {
    createBaseQueryObject() {
      const base = {};
      addParamToQueryObject(base, 'audience',    this.audienceId);
      addParamToQueryObject(base, 'start_level', this.startLevel);
      addParamToQueryObject(base, 'end_level',   this.endLevel);
      return base;
    },
  },
}
</script>

<style scoped>
.period-link {
  margin-right: 0.7rem;
}

.router-link-active {
  color: black;
  pointer-events: none;
  cursor: default;
}
</style>
